import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWallLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowWallLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M3.5 4V20H2V4H3.5ZM12.0607 7.75L8.56067 11.25H22V12.75H8.56065L12.0607 16.25L11 17.3107L5.68934 12L11 6.68934L12.0607 7.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWallLeft;
